import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Meta } from '@/components/Meta';
import { ProjectCard } from '@/components/ProjectCard';
import { Reveal } from '@/components/Reveal';
import { categoryLabels, projects } from '@/data/projects';
import type { ProjectCategory } from '@/data/types';
import { useLang } from '@/hooks/useLang';
import { cn } from '@/lib/cn';

const categories: (ProjectCategory | 'all')[] = ['all', 'residenze', 'retail', 'progetti'];

export function WorksPage() {
  const { t } = useTranslation();
  const lang = useLang();
  const [filter, setFilter] = useState<ProjectCategory | 'all'>('all');
  const list = filter === 'all' ? projects : projects.filter((p) => p.category === filter);

  return (
    <>
      <Meta title={t('meta.worksTitle')} description={t('meta.worksDesc')} />
      <header className="u-container pt-[22vh] pb-12">
        <p className="eyebrow text-stone">{t('works.eyebrow')}</p>
        <h1 className="mt-5 font-display text-6xl md:text-8xl">{t('works.title')}</h1>
      </header>

      <div className="u-container mb-12 flex flex-wrap gap-3 border-b border-line pb-6">
        {categories.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => setFilter(c)}
            className={cn(
              'rounded-full border px-5 py-2 text-xs uppercase tracking-[0.18em] transition-colors',
              filter === c ? 'border-ink bg-ink text-paper' : 'border-line text-stone hover:border-ink hover:text-ink',
            )}
          >
            {c === 'all' ? t('works.all') : categoryLabels[c][lang]}
          </button>
        ))}
      </div>

      <div className="u-container grid grid-cols-1 gap-x-8 gap-y-16 pb-[16vh] sm:grid-cols-2 lg:grid-cols-3">
        {list.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 3) * 0.08}>
            <ProjectCard project={p} />
          </Reveal>
        ))}
      </div>
    </>
  );
}
